import React from "react"

import '../styles/pages/AboutMe.css'

import Menu from "../components/Menu";
import WorkWith from "../components/WorkWith";
import YouSearch from "../components/YouSearch";
import Footer from "../components/Footer";
import AboutMeComponent from "../components/AboutMeComponent";
import Services from "../components/Services";


const AboutMe = () => {

    return (
        <>
            <header className='about-header'>
                <Menu/>
            </header>
            <AboutMeComponent/>
            <WorkWith/>
            <Services/>
            <YouSearch/>
            <Footer/>
        </>
    );
}

export default AboutMe;